<script>
	import TextInput from '@/Components/NewTextInput.svelte';

	export let offer_rules;

	export let is_update = false;

	let default_offer_rules = {
		max_payout_percentage: null,
		max_bonus_amount: null,
		bonus_valid_days: null
	};

	offer_rules = Object.assign({}, default_offer_rules, offer_rules);

	export let errors = {};
</script>

<div class="flex flex-row w-full text-left my-2 space-x-6">
	<TextInput
		label="Max Payout Percentage: (%)"
		name="max_payout_percentage"
		errors={errors && errors['offer_rules.max_payout_percentage']}
		type="number"
		min="0"
		step="1"
		className="w-1/6"
		suffix="%"
		required={true}
		labelClass="text-nowrap"
		disabled={is_update}
		bind:value={offer_rules.max_payout_percentage}
	/>
	<TextInput
		label="Bonus Valid for (in days):"
		name="bonus_valid_days"
		errors={errors && errors['offer_rules.bonus_valid_days']}
		type="number"
		min="0"
		max="30"
		step="1"
		suffix="days"
		className="w-1/6"
		required={true}
		labelClass="text-nowrap"
		disabled={is_update}
		bind:value={offer_rules.bonus_valid_days}
	/>
	<TextInput
		label="Max Bonus Amount: ($)"
		name="max_bonus_amount"
		errors={errors && errors['offer_rules.max_bonus_amount']}
		type="number"
		min="0"
		step="1"
		prefix="$"
		className="w-1/6"
		required={true}
		labelClass="text-nowrap"
		disabled={is_update}
		bind:value={offer_rules.max_bonus_amount}
	/>
</div>
